export const concatenateStringList = (
  items: string[],
  andWord = 'e',
  separator = ', ',
): string => {
  if (!items || items.length === 0) {
    return '';
  }

  if (items.length === 1) {
    return items[0];
  }

  if (items.length === 2) {
    return `${items[0]} ${andWord} ${items[1]}`;
  }

  const lastItem = items.pop();
  return `${items.join(separator)} ${andWord} ${lastItem}`;
};
